import { Chip, useDisclosure } from "@heroui/react";
import { useState, useEffect } from "react";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { LandlordUser } from "@/api/businessProfiles";

export function AdminChip({ adminId }: { adminId: number }) {
  const [item, setItem] = useState<LandlordUser | null>(null);
  const disclosure = useDisclosure();
  const items = useAppSelector((state) => state.handbooks.landlords);

  useEffect(() => {
    if (adminId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == adminId) || null);
    }
  }, [adminId, items]);

  return (
    <>
      {adminId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {adminId !== -1 && item !== null && (
        <Chip
          className="cursor-pointer"
          onClick={disclosure.onOpen}
          variant="dot"
          color="primary">
          {item?.first_name} {item?.last_name}
        </Chip>
      )}
      {adminId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
